import Role from "../enum/Role.enum";
import { User } from "../types/user";

const ALLOWED_PATHS_WITHOUT_OPEN_ACCOUNT = [
  "/mydata",
  "/change_password",
  "/panel",
];

export const isAgentBlockedByAccountStatus = (
  user: User | null,
  roles: string[],
) => {
  if (!user) {
    return false;
  }

  return (
    roles.includes(Role.AGENT) &&
    !roles.includes(Role.AGENT_ADMIN) &&
    !user.has_open_account
  );
};

export const canAccessPathWithoutOpenAccount = (path: string) => {
  return ALLOWED_PATHS_WITHOUT_OPEN_ACCOUNT.includes(path);
};
